// third-party
import { FormattedMessage } from "react-intl";
import libraryIcon from "../assets/icons/document-attachment.svg";

const icons = {
  library: () => <img src={libraryIcon} alt="library icon" />,
};

const library = {
  id: "library",
  title: <FormattedMessage id="library" defaultMessage="Bibliothèque" />,
  type: "group",
  url: "/library",
  icon: icons.library,
};

export default library;
